import { TitleWithDivider } from "@common/TitleWithDivider";
import ContactProfileForm from "@components/Forms/ContactProfileForm";
import pageHeaders from "@constants/PageHeaders";

const ViewExternalPhonebookPage: React.FC = () => {
  return (
    <>
      <div>
        <TitleWithDivider
          titleText={pageHeaders.KAKELY.phonebookEdit}
          useDivider={true}
        />
        <ContactProfileForm></ContactProfileForm>
      </div>
    </>
  );
};

export default ViewExternalPhonebookPage;
